export default "/images/SuzanErcan.jpg?c5169c850c0d9a5d6d6458049b2d7d89";